import React, { FunctionComponent } from 'react';
import loginAuthLeftPanel from 'assets/images/login-auth-left-panel.png';
import Styles from './LoginLeftSection.module.scss';

const LoginLeftSection: FunctionComponent = () => (
  <div className={Styles.panel}>
    <img
      className={Styles.image}
      src={loginAuthLeftPanel}
      alt="Moderate Politics — A platform for moderates and independents."
      width={720}
      height={900}
      decoding="async"
    />
  </div>
);

export default LoginLeftSection;
